import { style } from '@vanilla-extract/css'

import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'

export const home = style({})

export const home_container = style({
  '@media': {
    [getMediaQuery('md')]: {
      display: 'flex',
    },
  },
})

export const home_contents__left = style({})

export const home_contents__right = style({})

export const home_contents = style({
  '@media': {
    [getMediaQuery('md')]: {
      width: '50%',
    },
  },
})
